import CustomModal from "Components/CommonComponents/CustomModal";
import { StudentContext } from "Context/StudentContext";
import ChapterContentList from "Pages/StudentPortfolio/StudentEngagement/ChapterContentList";
import CourseSelectionMainPage from "Pages/StudentPortfolio/StudentEngagement/CourseSelectionMainPage";
import EngagementPackageModal from "Pages/StudentPortfolio/StudentEngagement/EngagementPackageModal";
import EnagagementReportMain from "Pages/StudentPortfolio/StudentEngagement/EngagementReportMain";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Spinner } from "reactstrap";
import {
  BASE_URL,
  FETCH_STUDENT_COURSE,
  FETCH_STUDENT_PACKAGE,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DraggableModal from "utilFunctions/shared/DraggableModal";

function StudentEngagementHome() {
  const { selectedStudent } = useContext<any>(StudentContext);
  const [modal, setModal] = useState<boolean>(false);
  const { screen } = useWindowSize();
  const [currentTab, setCurrentTab] = useState<any>("0");
  const [packageDeatils, setPackageDeatils] = useState([]);
  const [selectePackage, setselectedPackage] = useState<any>();
  const [courseDetails, setCourseDetails] = useState<any>([]);
  const [chapterDetails, setChapterDetails] = useState<any>([]);
  const [selectedCourses, setSelectedCourses] = useState<any>();
  const [collapseOpen, setCollapseOpen] = useState<any>();
  const [collapseOpenIndex, setCollapseOpenIndex] = useState<any>(null);
  const { makeRequest: fetchStudentPackage, loading } = useGetApi(
    (res) => {
      if (res?.data && res?.data?.packages.length) {
        const packageDeatils = res.data.packages.map((el: any) => {
          return { ...el, value: el.id, label: el.title };
        });
        setPackageDeatils(packageDeatils);
        setselectedPackage(packageDeatils[0]);
        setModal(true);
      }
    },
    (error) => {
      setModal(false);

      console.log(error);
    }
  );
  const { makeRequest: fetchStudentCourse, loading: chapterLoading } =
    useGetApi(
      (res) => {
        if (res?.data && res?.data?.chapters.length) {
          setChapterDetails(res.data.chapters);
        } else {
          setChapterDetails([]);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  const toggle = () => {
    setModal(!modal);
    if (selectePackage && selectePackage != null) {
      fetchCourseDetails(selectePackage);
    }
  };
  useEffect(() => {
    if (selectedStudent && selectedStudent?.psid) {
      const url =
        BASE_URL + FETCH_STUDENT_PACKAGE + `?psId=${selectedStudent.psid}`;
      fetchStudentPackage(url);
    }
  }, []);
  const fetchCourseDetails = (selectedPackag: any) => {
    const courseId = selectedPackag.courses[0].id;
    setCourseDetails(selectedPackag.courses);
    // setselectedPackage(selectedPackag.id);
    setSelectedCourses(selectedPackag.courses[0]);
    const userClass = selectedPackag.courses[0].classes[0];
    const url =
      BASE_URL +
      FETCH_STUDENT_COURSE +
      `?psId=${selectedStudent.psid}&packageId=${selectedPackag.id}&courseId=${courseId}&userClass=${userClass}`;
    fetchStudentCourse(url);
  };
  const handleSelectedPackage = (selectePackage: any) => {
    if (selectePackage) {
      console.log(selectePackage, "selectePackage called 77");
      setChapterDetails([]);
      setCurrentTab("0");
      setCollapseOpen(false);
      setCollapseOpenIndex(null);
      fetchCourseDetails(selectePackage);
    }
  };
  const handleCourseSelectionForChapter = (item: any) => {
    setCurrentTab("0");
    setCollapseOpen(false);
    setCollapseOpenIndex(null);
    const courseId = item.id;
    const userClass =
      item?.classes && item.classes != undefined ? item.classes[0] : "";
    const url =
      BASE_URL +
      FETCH_STUDENT_COURSE +
      `?psId=${selectedStudent.psid}&packageId=${selectePackage.id}&courseId=${courseId}&userClass=${userClass}`;
    fetchStudentCourse(url);
  };
  const onClosePaneHandler = () => {
    console.log("");
  };

  return (
    <div
      className="mt-3 p-3"
      style={{ backgroundColor: "#EEF2FE", borderRadius: "16px" }}
    >
      {["xxl", "xl", "lg"].includes(screen) ? (
        <CustomModal
          size="md"
          modal={modal}
          toggle={toggle}
          backdrop={true}
          centered={true}
          title="Select your package"
        >
          <EngagementPackageModal
            setselectedPackage={setselectedPackage}
            selectePackage={selectePackage}
            packageDeatils={packageDeatils}
            fetchCourseDetails={fetchCourseDetails}
            toggle={toggle}
          />
        </CustomModal>
      ) : (
        <DraggableModal
          initHeight={"fit-content"}
          isPaneOpen={modal}
          togglePane={toggle}
          onClose={onClosePaneHandler}
        >
          <div className="p-1">
            <EngagementPackageModal
              setselectedPackage={setselectedPackage}
              selectePackage={selectePackage}
              packageDeatils={packageDeatils}
              fetchCourseDetails={fetchCourseDetails}
              toggle={toggle}
            />
          </div>
        </DraggableModal>
      )}
      <Card className="main-card-container-course-selection">
        {loading ? (
          <div className="d-flex flex-row w-100 h-50 p-5 justify-content-center align-items-center">
            <Spinner color="info" />
          </div>
        ) : (
          <div className="w-100 row-container-course-selection">
            <Col
              xs={12}
              sm={12}
              md={6}
              className="row-container-course-selection-package mb-2"
            >
              <EnagagementReportMain
                packageDeatils={packageDeatils}
                selectedPackage={selectePackage}
                setselectedPackage={setselectedPackage}
                handleSelectedPackage={handleSelectedPackage}
              />
            </Col>
            <div className="subject-container-main">
              <CourseSelectionMainPage
                courseDetails={courseDetails}
                selectedCourses={selectedCourses}
                setSelectedCourses={setSelectedCourses}
                handleCourseSelectionForChapter={
                  handleCourseSelectionForChapter
                }
              ></CourseSelectionMainPage>
            </div>
          </div>
        )}
      </Card>
      <Card className="p-3 mb-0">
        {loading ? (
          <div className="d-flex flex-row w-100 h-50 p-5 justify-content-center align-items-center">
            <Spinner color="info" />
          </div>
        ) : (
          <ChapterContentList
            chapterLoading={chapterLoading}
            courseDetails={courseDetails}
            selectedCourses={selectedCourses}
            chapterDetails={chapterDetails}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            selectePackage={selectePackage}
            fetchStudentCourse={fetchStudentCourse}
            collapseOpen={collapseOpen}
            setCollapseOpen={setCollapseOpen}
            collapseOpenIndex={collapseOpenIndex}
            setCollapseOpenIndex={setCollapseOpenIndex}
          />
        )}
      </Card>
    </div>
  );
}

export default StudentEngagementHome;
